// Stripe's amounts are in a currency's minor units, which for most currencies are hundredths and for some are
// the whole unit (a buyer paying in yen under Adaptive Pricing, say). Stripe's own list
// (https://docs.stripe.com/currencies#zero-decimal), so it matches what Stripe sends, not what Intl assumes.
const ZERO_DECIMAL = new Set([
  "bif",
  "clp",
  "djf",
  "gnf",
  "jpy",
  "kmf",
  "krw",
  "mga",
  "pyg",
  "rwf",
  "ugx",
  "vnd",
  "vuv",
  "xaf",
  "xof",
  "xpf",
]);

// How many minor units make one of `currency`: 1 or 100.
export function minorPerUnit(currency: string): number {
  return ZERO_DECIMAL.has(currency.toLowerCase()) ? 1 : 100;
}

// An amount in minor units as the currency's major unit: 9.90, or 1480 for yen.
export function majorUnits(minor: number, currency: string): number {
  return minor / minorPerUnit(currency);
}
